import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class AESEncryptDecryptService {

  secretKey = "DanRodCaiRogRaf";
  constructor() { }

  encrypt(textToEcrypt : string) : string{
    let retorno = CryptoJS.AES.encrypt(textToEcrypt+" ", this.secretKey.trim()).toString();
     return retorno
  }

  decrypt(textToDecrypt : string){

    let retorno : string = "";

    if(textToDecrypt != null){
     retorno = CryptoJS.AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(CryptoJS.enc.Utf8)  ;
    }
     return retorno.trim()
  }
}